import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ff } from '@atlassian/jira-feature-flagging';
import { useGlobalChangeboarding } from '../../controllers/store/global/index.tsx';
import { ChangeboardingProviders } from '../../services/store/index.tsx';
import { UNLOCKED_STEP_ID } from './constants.tsx';
import { Wizard } from './index.tsx';
import { UNLOCKED_STEP_ID as UNLOCKED_STEP_ID_OPTIMAL } from './optimal/constants.tsx';
import { Wizard as OptimalWizard } from './optimal/index.tsx';

const WelcomeModalRendererInner = () => {
	const { isWelcomeModalActivated, finalWelcomeModalIsOpen, handleCloseWelcomeModal } =
		useGlobalChangeboarding();

	if (!isWelcomeModalActivated) {
		return null;
	}

	return ff('platform.show-optimal-tooling_brgom') ? (
		<OptimalWizard
			isOpen={Boolean(finalWelcomeModalIsOpen)}
			onClose={handleCloseWelcomeModal}
			defaultStep={UNLOCKED_STEP_ID_OPTIMAL}
		/>
	) : (
		<Wizard
			isOpen={Boolean(finalWelcomeModalIsOpen)}
			onClose={handleCloseWelcomeModal}
			defaultStep={UNLOCKED_STEP_ID}
		/>
	);
};

export const WelcomeModalRenderer = () => (
	<JSErrorBoundary
		fallback="flag"
		teamName="alexstrasza"
		packageName="jiraEocChangeboarding"
		id="jiraEocChangeboarding"
	>
		<ChangeboardingProviders>
			<WelcomeModalRendererInner />
		</ChangeboardingProviders>
	</JSErrorBoundary>
);
